export default "__VITE_ASSET__Cxt8ZLxF__"